import { KeyboardEvent, useState } from 'react';
import HeaderSort from './HeaderSort';
import styles from './header.module.scss';
import { SortedColumn, HeaderPropSortCallback } from '../models';

export interface HeaderProps {
  column: SortedColumn;
  onSort: HeaderPropSortCallback;
}

export default function Header({ column, onSort }: HeaderProps) {
  const [sortDirection, setSortDirection] = useState(column.direction);

  const sortWrapper = () => {
    if (!column.sortingEnabled) return;

    const newDirection = sortDirection === 'Asc' ? 'Desc' : 'Asc';
    column.direction = newDirection; // eslint-disable-line no-param-reassign
    setSortDirection(newDirection);
    onSort(column);
  };

  const onKeyUpHeader = (event: KeyboardEvent) => {
    if (event?.key === 'Enter') {
      sortWrapper();
    }
  };

  const textColumn = () => (
    <>
      <span>{column.title}</span>
      {column.tooltip && (
        <span className="align-self-center">{column.tooltip}</span>
      )}
      {column.sortingEnabled === true && (
        <div className="headerIcon align-self-center">
          {sortDirection && <HeaderSort direction={sortDirection} />}
        </div>
      )}
    </>
  );

  return (
    <div
      role="presentation"
      className={`${styles.headerContainer} ${
        column.className && column.className.length > 0 ? column.className : ''
      }`}
      onClick={() => sortWrapper()}
      onKeyUp={(event: KeyboardEvent) => onKeyUpHeader(event)}
    >
      {column.customHeaderCell ? column.customHeaderCell : textColumn()}
    </div>
  );
}
